export class DocumentsActions {
  static readonly UPDATE_FILTERS = '[DOCUMENTS] UPDATE_FILTERS';
  static readonly UPDATE_CHANGES_HISTORY_FILTERS = '[DOCUMENTS] UPDATE_CHANGES_HISTORY_FILTERS';
};
